import { Component, EventEmitter, Input, NgModule, Output, ViewEncapsulation } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

import { CommonModule } from '@angular/common';
import { WButtonModule } from '@wipo/w-angular/w-button';

@Component({
  selector: 'w-action-bar',
  templateUrl: './w-action-bar.component.html',
  styleUrls: ['./w-action-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('openClose', [
      state('open', style({
        display: 'block'
      })),
      state('closed', style({
        display: 'none'
      })),
      transition('open => closed', [animate('0.5s')]),
      transition('closed => open', [animate('0.5s')])
    ])
  ],
  host: {
    class: 'b-action-bar',
    '[class.b-action-bar--workbench]': 'sticky',
    '[@openClose]': 'open ? "open" : "closed"',
  },
  standalone: false
})
/*
@id w-action-bar
@name w-action-bar
@status release
@description action bar used on top of table, use size=small for any action buttons
*/
export class WActionBarComponent {
  @Input() open: boolean = true; // alternatively show/hide using ngIf
  @Input() sticky: boolean = false;
  @Input() message: string = '';
  @Input() labelCancel?: string; // label of cancel button

  @Output() wClosed = new EventEmitter<void>();
  doClose() {
    this.open = false;
    this.wClosed.emit();
  }
}
@NgModule({
  imports: [CommonModule, WButtonModule],
  exports: [WActionBarComponent],
  declarations: [WActionBarComponent]
})
export class WActionBarModule { }